import {api} from "@/configs";
import {defineStore} from "pinia";
import {apiUrls} from "@/constants";

import {notification} from "ant-design-vue";


export const usePodcastCategoryStore = defineStore("podcastCategory", {

    state: () => {
        return {
            podcastCategories: []
        };
    },
    getters: {},
    actions: {
        async fetchPodcastCategories() {
            try {
                const response = await api.get(apiUrls.podcastCategory);
                this.podcastCategories = response?.data?.data ?? [];
                return true;
            } catch (error) {
                this.podcastCategories = [];
                return false;
            }
        },
        async deletePodcastCategory(id) {
            try {
                const response = await api.delete(`${apiUrls.podcastCategory}/${id}`);
                await this.fetchPodcastCategories();
            } catch (error) {
            }
        },
        async addPodcastCategory(category = {name, description}) {
            try {
                const response = await api.post(apiUrls.podcastCategory, category);
                await this.fetchPodcastCategories();
                notification.success({
                    message: "Podcast Category Added Successfully",
                });
            } catch (error) {
                console.log(error);
                return false;
            }
        },
        async updatePodcastCategory(id, category = {name, description}) {
            try {
                const response = await api.patch(
                    `${apiUrls.podcastCategory}/${id}`,
                    category
                );
                await this.fetchPodcastCategories();
                notification.success({
                    message: "Podcast Category Updated Successfully",
                });
            } catch (error) {
            }
        },

    }

});
